import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPopupState } from '../../model/configuratorSlice';
import { CloseButton } from '../../shared/svg/components';
import RequestBudgetService from '../../services/RequestBudgetService';
import { PopupState, UnitStatus } from '../../model/constants';
import { TranslationUtility } from '../../utilities/TranslationUtility';
import UnitService from '../../services/UnitService';
import MainLoader from '../Loader/MainLoader';

const RequestBudgetPopup = () => {
  const { popupState, currentUnit, isLoadingUnitStatus } = useSelector(state => state.configurator);
  const unitMutation = UnitService();
  const requestBudgetMutation = RequestBudgetService();
  const dispatch = useDispatch();

  const isRequestBudgetPopupOpened = popupState === PopupState.RequestBudget;

  const isBudgetRequestAvailable = () => currentUnit !== null
    && currentUnit.allPricesDefined
    && currentUnit.status === UnitStatus.BudgetNotRequested
    && !currentUnit.confirmed;

  const getHeaderMessage = () => TranslationUtility.GetFormattedMessageForUI(
    'ui-request-budget-panel-title',
    'Formalizar Presupuesto',
  );

  const getRequestBudgetError = () => {
    if (currentUnit && currentUnit.status === UnitStatus.BudgetRequested) {
      if (currentUnit.confirmed) {
        return TranslationUtility.GetFormattedMessageForUI(
          'ui-request-budget-panel-status-confirmed',
          'Esta vivienda ya ha sido confirmada. '
          + 'Si tiene alguna duda sobre el proceso, póngase en contacto con su comercial.',
        );
      }
      return TranslationUtility.GetFormattedMessageForUI(
        'ui-request-budget-panel-status-already-formalized',
        // eslint-disable-next-line max-len
        'Esta vivienda ya ha sido formalizada. En caso de querer realizar modificaciones, póngase en contacto con su comercial.',
      );
    }
    if (!currentUnit.allPricesDefined) {
      return TranslationUtility.GetFormattedMessageForUI(
        'ui-request-budget-panel-status-pending-prices',
        'Esta vivienda tiene precios sin definir y no se puede formalizar en este momento. '
        + 'Si tiene alguna duda sobre el proceso, póngase en contacto con su comercial.',
      );
    }
    return TranslationUtility.GetFormattedMessageForUI(
      'ui-request-budget-panel-status-error-formalizing',
      'Se ha producido un error al formalizar.',
    );
  };

  const closePopupHandler = () => {
    dispatch(setPopupState(PopupState.None));
  };

  useEffect(() => {
    if (isRequestBudgetPopupOpened) {
      unitMutation.mutate();
    }
  }, [isRequestBudgetPopupOpened]);

  if (!isRequestBudgetPopupOpened) return null;

  if (isLoadingUnitStatus) return null;

  return (
    <div className={`request-budget-popup ${isRequestBudgetPopupOpened ? 'opened' : ''}`}>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        className={`background ${isRequestBudgetPopupOpened ? 'opened' : ''}`}
        type="button"
        onClick={closePopupHandler}
      />
      <div className={`background ${isRequestBudgetPopupOpened ? 'opened' : ''}`} />
      <div className={`panel ${isRequestBudgetPopupOpened ? 'opened' : ''}`}>
        <div className="header">
          {getHeaderMessage()}
        </div>
        {isBudgetRequestAvailable() ? (
          <>
            <div className="sub-header">
              {TranslationUtility.GetFormattedMessageForUI('ui-request-budget-panel-subtitle',
                '¿Está seguro que desea formalizar la configuración actual?')}
            </div>
            <div className="container-buttons">
              <button
                className="request-budget-button"
                type="button"
                disabled={requestBudgetMutation.isLoading}
                onClick={() => {
                  requestBudgetMutation.mutate();
                  closePopupHandler();
                }}
              >
                <span>
                  {requestBudgetMutation.isLoading
                      // eslint-disable-next-line max-len
                      ? TranslationUtility.GetFormattedMessageForUI('ui-request-budget-panel-button-loading', 'Formalizando…')
                      : TranslationUtility.GetFormattedMessageForUI('ui-request-budget-panel-button', 'Formalizar')}
                </span>
              </button>
            </div>
            <div className="body">
              {TranslationUtility.GetFormattedMessageForUI('ui-request-budget-panel-footer',
                // eslint-disable-next-line max-len
                'Al pulsar el botón ya no podrás volver a formalizar. Un comercial se pondrá en contacto para confirmar la configuración seleccionada.')}
            </div>
          </>
        ) : <div className="sub-header">{getRequestBudgetError()}</div>}
        <button
          className="close-button"
          type="button"
          onClick={closePopupHandler}
        ><CloseButton />
        </button>
      </div>
    </div>
  );
};

export default RequestBudgetPopup;
